<template>
  <div class="BAMCom" id="BAMCom">
    <v-BAMSide :userInfo="userInfo"></v-BAMSide>
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        :articleList="articleList"
        :userInfo="userInfo"
        :articleCount="articleCount"
        :currentPage="currentPage"
        :pageNum="pageNum"
        :isLoading="isLoading"
        @getArticleList="getArticleList"
        @getCategories="getCategories"
        @getWordCount="getWordCount"
        @clearArticleList="clearArticleList"
        @showMessage="showMessage"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      :articleList="articleList"
      :userInfo="userInfo"
      :articleCount="articleCount"
      :currentPage="currentPage"
      :pageNum="pageNum"
      :isLoading="isLoading"
      @getArticleList="getArticleList"
      @getCategories="getCategories"
      @getWordCount="getWordCount"
      @clearArticleList="clearArticleList"
      @showMessage="showMessage"
    ></router-view>
    <v-Message
      :messageShow="messageShow"
      :sendMessage="sendMessage"
    ></v-Message>
  </div>
</template>

<script>
import { currentUser } from "@/bmob";
import BAMSide from "@/components/BAM/side/side";
import Message from "@/components/common/Message/Message";
import defaultAvatar from "@/assets/img/defaultIcon.png";
export default {
  components: {
    "v-BAMSide": BAMSide,
    "v-Message": Message
  },
  data() {
    return {
      messageShow: false,
      sendMessage: "",
      userInfo: { avatar: defaultAvatar }
    };
  },
  props: {
    articleList: {
      type: Array,
      default: () => []
    },
    articleCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 20
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      currentUser()
        .then(result => {
          this.userInfo = {
            avatar: result.avatar,
            showName: result.showName,
            singName: result.singName,
            userId: result.id
          };
        })
        .catch(err => {
          console.log("err", err);
          //没有session，未登录（未按步骤操作）
          this.$router.push({ path: "/login" });
        });
    },
    showMessage(msg) {
      this.$emit("showMessage", msg);
    },
    getCategories() {
      this.$emit("getCategories");
    },
    getWordCount() {
      this.$emit("getWordCount");
    },
    getArticleList(data) {
      this.$emit("getArticleList", data);
    },
    clearArticleList() {
      this.$emit("clearArticleList");
    }
  }
};
</script>

<style scoped lang="less">
.BAMCom {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 50px;
  background-color: #fff;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// layout.vue?5752ae19